import axios from 'axios'
import { Modal } from 'antd'
import Qs from 'qs'

export const myAxios = (option) => {
  let defaultOption = {
    method: 'post',
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json',
    },
  }
  if(option.method === "get"){
    defaultOption = {
      method: 'get',
      transformRequest: [
        function (data) {
          data = Qs.stringify(data)
          return data
        },
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
    }
  }
  const options = {
    ...defaultOption,
    dataType: "json",
    credentials: 'include',
    ...option,
  }
  options.headers = { ...options.headers }
  return axios(options)
}

/**
 * 批量请求接口
 * @param funcs 请求方法
 * @returns {*}
 */
export const axiosAll = (funcs) => {
  return axios.all(funcs)
  .then(function (data) {
    return data
  });
}

let inTheRequest = {}
// 拦截器
axios.interceptors.request.use(config => {
  console.log('inTheRequest :>> ', inTheRequest);
  // // 中断接口
  if(config.url === '/template/ocr/OCR2WordFile.ajax' && inTheRequest['/user-center/ocrWebChat/queryinfo.ajax']){
    console.log('object :>> ', config.url);
    inTheRequest['/user-center/ocrWebChat/queryinfo.ajax']('interrupt')
  }
  // // 添加断开请求的方法
  config['cancelToken'] = new axios.CancelToken(function executor(cancel) {
    inTheRequest[config.url] = cancel //存储cancle
  })
  return config
},
error => {
  console.log(error) // for debug
  return Promise.reject(error)
})

axios.interceptors.response.use(respons => {
  // 接口请求完成去除接口中断方法
  delete inTheRequest[respons.config.url]
  if (respons.status  === 505) {
      window.location.href = '/';
  } else if (respons.status  === 508) {
      window.location.href = '/';
  } else if (respons.status === 507) {
      Modal.warning({
          title: '提示',
          content: '该帐号正在另一处登陆成功，请确认当前操作人。同一帐号不可以多人同时登陆！',
          okText: '退出，重新登陆',
          onOk: function () {
              window.location.href = '/login';
          }
      })
      return respons;
  } else {
    return respons ;
  }
}, error => {
  if (error.request.status  === 505) {
      window.location.href = '/';
  } else if (error.request.status === 507) {
    Modal.warning({
        title: '提示',
        content: '该帐号正在另一处登陆成功，请确认当前操作人。同一帐号不可以多人同时登陆！',
        okText: '退出，重新登陆',
        onOk: function () {
            window.location.href = '/';
        }
    })
  } else if (error.request.status === 404) {
    // Modal.warning({
    //     title: '提示',
    //     content: '404',
    //     okText: '退出，重新登陆',
    //     onOk: function (data) {
    //         window.location.href = '/login';
    //     }
    // })
  } else if (error.request.status === 508) {
    Modal.warning({
        title: '提示',
        content: '登录超时',
        okText: '退出，重新登陆',
        onOk: function () {
            window.location.href = '/';
        }
    })
  }
  // return {data: {status:error.response.status}}
  return Promise.reject(error);
})
